<template>
  <div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    shareInfo () {
      return this.$store.state.group.shareInfo
    }
  },
  watch: {
    shareInfo(val) {
      if (dianji.isWx) {
        this.init();
      }
    }
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    init() {
      this.$groupGet("/wallet/wechat/getInitJSSDKData", {
        businessSource: 20,
        url: location.href.split("#")[0]
      }).then(data => {
        if (data.errCode === 0) {
          this.auth(data)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.data.appId, // 必填，公众号的唯一标识
            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
            signature: data.data.signature, // 必填，签名
            jsApiList: ["onMenuShareTimeline","onMenuShareAppMessage", "chooseWXPay"] // 必填，需要使用的JS接口列表
          });
          wx.ready(() => {
            // 分享朋友圈
            wx.onMenuShareTimeline({
              title: this.shareInfo.title, // 分享标题
              link: this.shareInfo.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.shareInfo.imgUrl, // 分享图标
              success: (res)=> {
                this.$success("分享成功！");
              }
            });
            // 分享朋友
            wx.onMenuShareAppMessage({
              title: this.shareInfo.title, // 分享标题
              desc: this.shareInfo.desc, // 分享描述
              link: this.shareInfo.link,  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.shareInfo.imgUrl, // 分享图标
              success:(res)=> {
                console.log(this.shareInfo)
                this.$success("分享成功！");
              }
            });
          });
        }
      });
    },
    auth(data) {
          if (localStorage.openid) {
            this.$store.commit('group/setAuth',{openid:localStorage.openid})
            return
          }
          // snsapi_base  snsapi_userinfo 第一步用户授权，跳转目标页，在下一页得到code
          var redirect_urls = encodeURIComponent(location.origin);
          var urls = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            data.data.appId
          }&redirect_uri=${redirect_urls}&response_type=code&scope=snsapi_userinfo&state=${location.href.split("#")[1]}#wechat_redirect`;
          let code =  this.getUrlParam("code");
          if (code) {
            this.$groupGet('/wallet/wechat/getUserOpenId',{
              businessSource: 20,
              code: code
            }).then((data)=>{
              if (data.errCode === 0) {
                this.$store.commit('group/setAuth',data.data)
                localStorage.openid = data.data.openid || ''
                console.log('setAuth',data.data)
              }
            })
            let state =  this.getUrlParam("state");
            if (state) {
              this.$router.push({path:state})
            }
          } else {
            window.location.href = urls;
          }
    }
  },
  created() {
    if (dianji.isWx && (location.href.match("quoteDetail") === null)) {
      this.init();
    }
  }
};
</script>

<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/group/components/wxShare/index.vue